import React from 'react';

const PrintGradesTable = ({ details, moyenneSemestre }) => {
  const getMentionLabel = (noteSur20) => {
    if (noteSur20 >= 18) return 'Excellent';
    if (noteSur20 >= 16) return 'Très Bien';
    if (noteSur20 >= 14) return 'Bien';
    if (noteSur20 >= 12) return 'Assez Bien';
    if (noteSur20 >= 10) return 'Passable';
    return 'Insuffisant';
  };

  const totalCoefficients = details?.reduce((sum, detail) => {
    const coefficient = detail.moyenne_module?.module_classe?.coeficient || 1;
    return sum + coefficient;
  }, 0) || 0;

  const totalPoints = details?.reduce((sum, detail) => {
    const noteCoef = detail.moyenne_module?.moyenne_finale || 0;
    return sum + noteCoef;
  }, 0) || 0;

  return (
    <div className="grades-table" style={{ marginBottom: '6px' }}>
      <div style={{ marginBottom: '4px' }}>
        <h3 style={{ 
          fontSize: '10px', 
          fontWeight: 'bold', 
          margin: '0 0 3px 0',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          borderBottom: '1px solid #000',
          paddingBottom: '2px'
        }}>
          Détail des Notes par Module
        </h3>
      </div>
      
      <table className="compact-table" style={{ 
        width: '100%', 
        borderCollapse: 'collapse', 
        border: '2px solid #000',
        fontSize: '7pt'
      }}>
        <thead>
          <tr>
            <th style={{ 
              border: '1px solid #000', 
              padding: '3px 4px', 
              textAlign: 'center', 
              fontWeight: 'bold', 
              backgroundColor: '#e0e0e0',
              fontSize: '7pt',
              textTransform: 'uppercase',
              letterSpacing: '0.3px'
            }}>
              Module
            </th>
            <th style={{ 
              border: '1px solid #000', 
              padding: '3px 4px', 
              textAlign: 'center', 
              fontWeight: 'bold', 
              backgroundColor: '#e0e0e0',
              fontSize: '7pt'
            }}>
              Moy./20
            </th>
            <th style={{ 
              border: '1px solid #000', 
              padding: '3px 4px', 
              textAlign: 'center', 
              fontWeight: 'bold', 
              backgroundColor: '#e0e0e0',
              fontSize: '7pt'
            }}>
              Coef.
            </th>
            <th style={{ 
              border: '1px solid #000', 
              padding: '3px 4px', 
              textAlign: 'center', 
              fontWeight: 'bold', 
              backgroundColor: '#e0e0e0',
              fontSize: '7pt'
            }}>
              Note × Coef.
            </th>
            <th style={{ 
              border: '1px solid #000', 
              padding: '3px 4px', 
              textAlign: 'center', 
              fontWeight: 'bold', 
              backgroundColor: '#e0e0e0',
              fontSize: '7pt'
            }}>
              Rang
            </th>
            <th style={{ 
              border: '1px solid #000', 
              padding: '3px 4px', 
              textAlign: 'center', 
              fontWeight: 'bold', 
              backgroundColor: '#e0e0e0',
              fontSize: '7pt'
            }}>
              Mention
            </th>
          </tr>
        </thead>
        <tbody>
          {details && details.length > 0 ? (
            details.map((detail, index) => {
              const moyenne = detail.moyenne_module;
              const module = moyenne?.module_classe?.module;
              const coefficient = moyenne?.module_classe?.coeficient || 1;
              const noteBase = moyenne?.moyenne_finale ? (moyenne.moyenne_finale / coefficient) : 0;
              const noteCoef = moyenne?.moyenne_finale || 0;
              const rang = moyenne?.rang_module ? `${moyenne.rang_module}e` : 'N/A';
              const mention = getMentionLabel(noteBase);
              
              return (
                <tr key={detail.id || index}>
                  <td style={{ 
                    border: '1px solid #000', 
                    padding: '3px 4px',
                    fontWeight: '500',
                    fontSize: '7pt'
                  }}>
                    <div style={{ fontWeight: '600' }}>
                      {module?.libelle || 'Module inconnu'}
                    </div>
                  </td>
                  <td style={{ 
                    border: '1px solid #000', 
                    padding: '3px 4px', 
                    textAlign: 'center', 
                    fontWeight: 'bold',
                    fontSize: '7pt'
                  }}>
                    {noteBase.toFixed(2)}
                  </td>
                  <td style={{ 
                    border: '1px solid #000', 
                    padding: '3px 4px', 
                    textAlign: 'center', 
                    fontWeight: 'bold',
                    fontSize: '7pt'
                  }}>
                    {coefficient}
                  </td>
                  <td style={{ 
                    border: '1px solid #000', 
                    padding: '3px 4px', 
                    textAlign: 'center', 
                    fontWeight: 'bold',
                    fontSize: '7pt'
                  }}>
                    {noteCoef.toFixed(2)}
                  </td>
                  <td style={{ 
                    border: '1px solid #000', 
                    padding: '3px 4px', 
                    textAlign: 'center',
                    fontWeight: '500',
                    fontSize: '7pt'
                  }}>
                    {rang}
                  </td>
                  <td style={{ 
                    border: '1px solid #000', 
                    padding: '3px 4px', 
                    textAlign: 'center',
                    fontWeight: '500',
                    fontSize: '7pt'
                  }}>
                    {mention}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6" style={{ 
                border: '1px solid #000', 
                padding: '4px', 
                textAlign: 'center', 
                color: '#666',
                fontStyle: 'italic',
                fontSize: '7pt'
              }}>
                Aucun module disponible
              </td>
            </tr>
          )}
          
          {/* Ligne de total */}
          {details && details.length > 0 && (
            <tr style={{ backgroundColor: '#f0f0f0' }}>
              <td style={{ 
                border: '1px solid #000', 
                padding: '4px', 
                fontWeight: 'bold',
                fontSize: '8pt',
                textTransform: 'uppercase'
              }}>
                TOTAL
              </td>
              <td style={{ 
                border: '1px solid #000', 
                padding: '4px', 
                textAlign: 'center',
                fontWeight: 'bold'
              }}>
                -
              </td>
              <td style={{ 
                border: '1px solid #000', 
                padding: '4px', 
                textAlign: 'center', 
                fontWeight: 'bold',
                fontSize: '8pt'
              }}>
                {totalCoefficients}
              </td>
              <td style={{ 
                border: '1px solid #000', 
                padding: '4px', 
                textAlign: 'center', 
                fontWeight: 'bold',
                fontSize: '8pt'
              }}>
                {totalPoints.toFixed(2)}
              </td>
              <td style={{ 
                border: '1px solid #000', 
                padding: '4px', 
                textAlign: 'center',
                fontWeight: 'bold'
              }}>
                -
              </td>
              <td style={{ 
                border: '1px solid #000', 
                padding: '4px', 
                textAlign: 'center',
                fontWeight: 'bold'
              }}>
                -
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PrintGradesTable;
